import { TFunction } from "i18next";

/** English labels persisted by older return submissions before locale-aware storage. */
const REASON_KEY_BY_CANONICAL: Record<string, string> = {
  "damaged product": "returnsManagement.damaged",
  "near expiry / expired": "returnsManagement.expired",
  "wrong item delivered": "returnsManagement.wrongItem",
  "defective product": "returnsManagement.defective",
  other: "returnsManagement.other",
};

const REASON_I18N_KEYS = [
  "returnsManagement.damaged",
  "returnsManagement.expired",
  "returnsManagement.wrongItem",
  "returnsManagement.defective",
  "returnsManagement.other",
] as const;

/** Maps stored return reason text (English or localized) to the active locale. */
export function localizeReturnReason(
  reason: string | null | undefined,
  t: TFunction
): string {
  const raw = String(reason ?? "").trim();
  if (!raw) return "-";

  const canonicalKey = REASON_KEY_BY_CANONICAL[raw.toLowerCase()];
  if (canonicalKey) return t(canonicalKey);

  for (const key of REASON_I18N_KEYS) {
    if (raw === t(key, { lng: "en" })) return t(key);
  }

  return raw;
}
